import { useEffect } from 'react';
import { StandaloneUsageTracker } from './UsageTracker';
import { CRM_LOCATION_NAMES } from 'crm-cards-sdk/constants/CrmLocationName';
import { denormalizeTypeId } from 'customer-data-objects/constants/ObjectTypeIds';
const DONT_TRACK_LIST = [CRM_LOCATION_NAMES.CRM_RECORD_MIDDLE, CRM_LOCATION_NAMES.CRM_RECORD_RIGHT, CRM_LOCATION_NAMES.CRM_RECORD_HIGHLIGHT, CRM_LOCATION_NAMES.CUSTOM];
function shouldTrackLocationView(location) {
  return !DONT_TRACK_LIST.includes(location);
}
function getScreenName(location) {
  if (location === CRM_LOCATION_NAMES.CRM_RECORD_LEFT) {
    return 'CRM_RECORD_PAGE';
  }
  return location;
}
function isRecordLocation(location) {
  return location === CRM_LOCATION_NAMES.CRM_RECORD_LEFT || location === CRM_LOCATION_NAMES.CRM_RECORD_MIDDLE || location === CRM_LOCATION_NAMES.CRM_RECORD_RIGHT;
}
function getSubscreenName(location, loggingTag) {
  if (isRecordLocation(location)) {
    // Records locations get logged as "CRM_RECORD_PAGE" for the screen so we'll use subscreen for the location
    return location;
  }

  // otherwise we'll use the logging tag for the subscreen
  return loggingTag;
}
export function useTrackLocationView({
  location,
  loggingTag,
  objectTypeId
}) {
  useEffect(() => {
    if (shouldTrackLocationView(location)) {
      StandaloneUsageTracker.track('CRM Cards SDK', 'Profile View', {
        screen: getScreenName(location),
        subscreen: getSubscreenName(location, loggingTag),
        objectTypeId,
        objectType: objectTypeId ? denormalizeTypeId(objectTypeId) : undefined
      });
    }
  }, [location, loggingTag, objectTypeId]);
}